import * as React from "react"
import styled from "styled-components"
import { Composition, query } from "atomic-layout"

export interface OverlineProps {
  text?: string,
  color?: string,
}

const StyledOverline = styled.div`
  margin-bottom: var(--gutter);
  background-color: ${props => props.$color};
  display: inline-flex;
  clip-path: polygon(16px 0%, 100% 0%, calc(100% - 16px) 100%, 0% 100%);
  padding: 5px 30px;
  color: #fff;
  font-size: 13.5px;
  font-weight: 700;
  line-height: 150%;
  text-transform: uppercase;
`

const Overline = ({ text = "", color = "#C69214", className = "" }: OverlineProps) => (
    <StyledOverline $color={color} className={className}>{text}</StyledOverline>
)

export default Overline
